import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { Icon, LinkTo } from '@common/components';
import { useClickOutside } from '@common/hooks/useClickOutside';
import dropdownClasses from './DropdownMenu.module.scss';

const allDropDowns = [];

export function DropdownMenu({ className, children, label, href }) {
  const wrapperRef = useRef(null);

  const [clickOutside] = useClickOutside(wrapperRef);

  const [isOpen, setIsOpen] = useState(false);

  const toggling = (event) => {
    event.preventDefault();
    allDropDowns.forEach((so) => so(false));
    setIsOpen(!isOpen);
    return false;
  };

  useEffect(() => {
    if (allDropDowns.indexOf(setIsOpen) <= -1) {
      allDropDowns.push(setIsOpen);
    }
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [clickOutside]);

  return (
    <div
      className={cx(dropdownClasses.dropdownContainer, className)}
      ref={wrapperRef}
    >
      <div>
        <LinkTo
          className={cx([dropdownClasses.dropdownHeader])}
          href={href}
          onClick={toggling}
          suffix={
            <Icon icon={faAngleDown} className={dropdownClasses.iconWorld} />
          }
        >
          {label}
        </LinkTo>
      </div>

      <div
        className={dropdownClasses.dropdownListWrapper}
        onClick={() => setIsOpen(false)}
        aria-hidden="true"
        role="button"
        tabIndex="0"
      >
        {isOpen && (
          <div className={dropdownClasses.dropdownListContainer}>
            <ul className={dropdownClasses.dropdownList}>{children}</ul>
          </div>
        )}
      </div>
    </div>
  );
}

export function OptionMenu({ className, children, href }) {
  return (
    <li className={dropdownClasses.listItemContainer}>
      <LinkTo className={cx(dropdownClasses.listItem, className)} href={href}>
        {children}
      </LinkTo>
    </li>
  );
}

DropdownMenu.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string,
  label: PropTypes.string,
};

OptionMenu.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.node,
};
